module.exports = __webpack_public_path__ + "fonts/muuq-fonts.f884c8d6.woff";